import { callApi } from './ApiClient';

const getTimelineStatus = (data, dispatch) => {
  return callApi('GET', '/timeline_status', data, dispatch);
}

const postTimelineStatus = (data, dispatch) => {
  return callApi('POST', '/timeline_status', data, dispatch);
}

const deleteTimelineStatusById = (id, dispatch) => {
  return callApi('DELETE', `/timeline_status/${id}`, null, dispatch);
}

const getRecordingData = (id, dispatch) => {
  return callApi('GET', `/timeline_status/${id}/recording_data`, null, dispatch);
}

const getTimelineStatusById = (id, dispatch) => {
  return callApi('GET', `/timeline_status/${id}`, null, dispatch);
}

export const TimelineApi = {
  getTimelineStatus,
  postTimelineStatus,
  deleteTimelineStatusById,
  getRecordingData,
  getTimelineStatusById,
};



// WEBPACK FOOTER //
// ./src/redux/api/TimelineApi.js